var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_24",
    transform: "translate(8137 4408)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24574",
    "data-name": "Rechteck 24574",
    width: 24,
    height: 24,
    transform: "translate(-8137 -4408)",
    fill: "rgba(102,102,102,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5559",
    "data-name": "Pfad 5559",
    d: "M22.4,19.86,13.272,2.743a1.441,1.441,0,0,0-2.544,0L1.6,19.86a1.441,1.441,0,0,0,1.272,2.12H21.129A1.441,1.441,0,0,0,22.4,19.86ZM11,7h2v8H11Zm2,11.965H11V16.956h2Z",
    transform: "translate(-8137 -4407.979)",
    fill: "#ff9600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning24);
export default __webpack_public_path__ + "static/media/Warning_24.f1492b5b78e48a8bc35971d87bedc40a.svg";
export { ForwardRef as ReactComponent };